// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';

import {
  mt, mb, pb, pl, px, pt, py, p
} from 'styled-components-spacing';

import { sectionSpacing } from '@components/Wrappers/styles';

import { StyledCoverMaxWidthPadding as StyledCoverMaxWidthPaddingOriginal } from '@components/Wrappers';

import { HeadlineSection, SubHeadlineSection } from '@components/Headlines';

import theme from '@theme';

export const StyledTeaserCandidates = styled(Grid)`
  justify-content: center;

  ${breakpoint('desktop')`
    ${pt(5.5)}
    ${px(5.5)}
    height: 540px;
    ${sectionSpacing}
  `}
`;

export const StyledHeadlineTextSection = styled(HeadlineSection)`

`;

export const StyledSubHeadlineSection = styled(SubHeadlineSection)`
  ${breakpoint('desktop')`
    color: ${theme.colors.black};
  `}
`;

export const StyledCoverMaxWidthPadding = styled(StyledCoverMaxWidthPaddingOriginal)`
  position: relative;
  ${py(5)}

  ${breakpoint('desktop')`
    ${py(0)}
  `}
`;

export const StyledTeaserCandidatesMap = styled(Grid.Unit)`
  width: 100%;
  height: 300px;
  max-height: 100%;
  z-index: 10;

  ${breakpoint('desktop')`
    height: auto;
  `}

  & > svg {
    width: 100%;
    height: auto;
    object-fit: cover;
    height: 100%;
  }
`;

export const StyledGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${theme.gradients.linearFadedBlueSoftBlueLTR};

  ${breakpoint('desktop')`
    display: none;
  `}
`;

export const VerticalGrid = styled(Grid.Unit)`
  position: relative;
  text-align: left;
  ${mt(3)}

  ${breakpoint('desktop')`
    ${mt(0)}
    ${pl(4.5)}
  `}
`;

export const StyledHospitalLogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${breakpoint('tablet', 'desktop')`
  justify-content: space-evenly;
`}
`;

export const StyledHospitalLogoMainWrapper = styled.div`
  width: 100%;
`;
export const StyledHospitalLogo = styled.div`
  ${p(2)};
  img {
    height: 160px;
    width: 160px;
  }
  ${breakpoint('mobile', 'desktop')`
  img {
    height: 135px;
    width: 135px;
  }
`}
`;

export const StyledTeaserCandidatesTitle = styled.h2`
  ${mb(4)}
  font-size:22px;
  font-weight:700;
  line-height:1.5em;
  display: ${props => (props.laptop ? 'none' : 'justify')};
  ${breakpoint('mobile', 'desktop')`
  text-align:center;
  font-size:25px;
  `}
`;

export const StyledTeaserCandidatesText = styled.div`
  ${mb(3)}
  line-height:1.5em;
  font-size:20px;
`;

export const StyledExampleSearchText = styled.div`
  ${mb(4)}

  font-size: 16px;
  font-weight: 600;

  & > .title {
    ${mb(3)}
  }

  & > * > b {
    font-weight: bold;
  }

  ${breakpoint('desktop')`
    position: absolute;
    bottom: 0;
    color: ${theme.colors.darkBlue};
    ${pb(2)}
    ${mb(0)}
  `}
`;

export const StyledButtonContainer = styled.div`
  display: flex;
`;
